import { useEffect, useRef, useState } from 'react';

// Lightweight intersection-observer hook used to fade-up sections as they
// enter the viewport during scroll.
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px', ...options },
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [options.rootMargin, options.threshold]); // eslint-disable-line react-hooks/exhaustive-deps

  return [ref, visible];
}
